// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"8b5abcf4","183":"14fa44b0","233":"66b3bdf0","453":"04c79a43","469":"a800597b","906":"0329a072","997":"cc6743e7"}[chunkId] + ".chunk.js";
};